import {
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  List,
  ListItem,
  styled,
  Typography,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify'

const StyledButton = styled(Button)({
  backgroundColor: "#D0EFDB",
  color: "#13B04C",
  boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 10px",
  textTransform: "none",
  borderRadius: "20px",
  flex: "1 1 0%",
  whiteSpace: "nowrap",
  fontSize: "12px",
});

const StyledCancelButton = styled(Button)({
  backgroundColor: "rgb(239, 83, 80)",
  color: "white",
  boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 10px",
  textTransform: "none",
  borderRadius: "20px",
  flex: "1 1 0%",
  whiteSpace: "nowrap",
  fontSize: "12px",
});

const OrderDeliveryDetails = () => {
  const { orderId } = useParams();
  const [orderDetails, setOrderDetails] = useState({});

  const reloadData = async (orderId) => {
    axios
      .get(
        `${process.env.REACT_APP_SECRET}/api/Order/GetOrderDetailsByOrderId?orderId=` +
          orderId
      )
      .then((res) => {

        setOrderDetails(res.data);
      })
      .catch((err) => {
        console.warn(err);
      });
  }

  useEffect(() => {
  reloadData(orderId)
  }, [orderId]);

  const getLastFourDigits = (id) => {
    if (id) {
      const orderId = id.toString();
      return `${orderId.slice(-6)}`;
    }
  };

  console.log(orderDetails)

  const handleOrderStatusChangeAtDelivered = async () => {
    try {
      console.log(orderDetails)
      var kitchenIds = orderDetails?.subOrders[0]?.orderItemDetailViews.map((x) => x.kitchenId);

      console.log(kitchenIds)

      const updatedOrder = await axios
        .post(
          `${process.env.REACT_APP_SECRET}/api/Order/InsertIntoQueueManagementTableByServe?fromStatusCode=${6}&toStatusCode=${9}&orderId=${orderDetails?.id}&fromTable=${'qe_Ready'}`,
          kitchenIds
        )
        .then(() => {
          toast.success("Order Delivered", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });

          reloadData(orderDetails?.id);
        });
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div
      className="d-flex"
      style={{
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
    <Card sx={{ height: "100%"}}>
    <CardContent sx={{ textAlign: "center" }}>
    {orderDetails?.toStatus === 9 ? (
      <Typography
        variant="h5"
        component="div"
        sx={{ color: "#56595b", fontWeight: "bold" }}
      >
        This order is already delivered
      </Typography>
    ) : (
      <>
        <Typography
          variant="h5"
          component="div"
          sx={{ color: "#56595b", fontWeight: "bold" }}
        >
          OrderId #{getLastFourDigits(orderDetails?.id)}
        </Typography>

        <div
          className="d-flex"
          style={{ flexWrap: "wrap", gap: "10px", marginTop: "10px" }}
        >
          {orderDetails?.subOrders?.map((dt) => (
            <Card
              key={dt.id}
              sx={{
                width: "100%",
                margin: "auto",
                boxShadow: 3,
                borderRadius: 2,
              }}
              className="mt-2"
            >
              <CardContent sx={{ textAlign: "start", paddingBottom: "0px" }}>
                <div
                  className="d-flex"
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#56595b",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                  >
                    {dt.orderTypeName}
                  </Typography>
                  {dt.orderTypeName === "In-Store" ? (
                    <Typography>
                      <span
                        style={{
                          color: "#56595b",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                      >
                        Table No:
                      </span>{" "}
                      {dt.tableNoOrDeliveryAddress}
                    </Typography>
                  ) : (
                    <Typography>
                      <span
                        style={{
                          color: "#56595b",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                      >
                        Delivery Address:
                      </span>{" "}
                      {dt.tableNoOrDeliveryAddress}
                    </Typography>
                  )}
                </div>

                <List sx={{ paddingTop: "0px", paddingBottom: "0px" }}>
                  {dt.orderItemDetailViews.map((item, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        display: "block",
                        paddingTop: "0px",
                        paddingBottom: "0px",
                      }}
                    >
                      <div>
                        <div
                          className="d-flex"
                          style={{
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={{ color: "black" }}>
                            <strong>
                              {index + 1}. {item.itemName} * {item.qty}
                            </strong>
                          </Typography>
                          <div className="d-flex" style={{ gap: "5px" }}>
                            <Chip label={item.kitchenName} className="dineIn" />
                            <Chip
                              label={item.toStatusDetails}
                              className={`${
                                item.toStatusDetails === "Queue"
                                  ? "queue-status"
                                  : item.toStatusDetails === "Pending"
                                  ? "pending-status"
                                  : item.toStatusDetails === "Preparing"
                                  ? "preparing-status"
                                  : "ready-status"
                              }`}
                            />
                          </div>
                        </div>

                        <List sx={{ paddingTop: "0px", paddingBottom: "0px" }}>
                          {item.orderAddons.map((addon, addOnIndex) => (
                            <ListItem
                              key={addOnIndex}
                              sx={{
                                display: "block",
                                paddingTop: "10px",
                                paddingBottom: "0px",
                              }}
                            >
                              <div>
                                <Typography sx={{ color: "black" }}>
                                  {addon.addOnName} * {addon.qty}
                                </Typography>
                                <List
                                  sx={{
                                    paddingTop: "0px",
                                    paddingBottom: "0px",
                                  }}
                                >
                                  {addon.orderOptions.map(
                                    (option, optionIndex) => (
                                      <ListItem
                                        key={optionIndex}
                                        sx={{
                                          display: "block",
                                          paddingTop: "10px",
                                          paddingBottom: "0px",
                                        }}
                                      >
                                        <div className="d-flex">
                                          <Typography sx={{ color: "black" }}>
                                            {option.optionName} * {option.qty}{" "}
                                          </Typography>
                                          <span
                                            style={{ paddingLeft: "10px" }}
                                          >
                                            {" ("}
                                          </span>

                                          <List
                                            sx={{
                                              paddingTop: "0px",
                                              paddingBottom: "0px",
                                            }}
                                          >
                                            {option.orderSubOptions.map(
                                              (subOption, suboptionIndex) => (
                                                <ListItem
                                                  key={suboptionIndex}
                                                  sx={{
                                                    display: "block",
                                                    paddingTop: "0px",
                                                    paddingLeft: "0px",
                                                    paddingRight: "0px",
                                                  }}
                                                >
                                                  <div>
                                                    <Typography
                                                      sx={{ color: "black" }}
                                                    >
                                                      {
                                                        subOption.subOptionName
                                                      }
                                                    </Typography>
                                                  </div>
                                                </ListItem>
                                              )
                                            )}
                                          </List>
                                          {")"}
                                        </div>
                                      </ListItem>
                                    )
                                  )}
                                </List>
                              </div>
                            </ListItem>
                          ))}
                        </List>
                      </div>
                      <hr />
                    </ListItem>
                  ))}
                </List>
              </CardContent>{" "}
              <CardActions sx={{ paddingBottom: "1rem" }}>
                <StyledButton onClick={handleOrderStatusChangeAtDelivered}>
                  Mark as Complete
                </StyledButton>
                <StyledCancelButton>Cancel Order</StyledCancelButton>
              </CardActions>
            </Card>
          ))}
        </div>
      </>
    )}
  </CardContent>
</Card>
    </div>
  );
};

export default OrderDeliveryDetails;
